import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { FlightTicketApiService } from 'Services/ApiServices';
import { setLoader } from 'Store/Actions/Loading/LoadingAction';
import toast from 'react-hot-toast';
import { useModal } from 'Hooks';
import { DS_F2W_Edit } from 'Constants/F2wRolesConstants';
import NewAgGridTable from 'Views/New/AgGridTable/NewAgGridTable';
import NewFlightTicketModal from 'Views/New/Components/NewFlightTicketModal';
import { getSeasons, getCountries, getDestinations, getJobTitles } from 'Store/Actions/MasterData/MasterDataAction';
import F2WCustomLogger from 'Services/F2WCustomLogger';

const TicketCreatedToast = ({ message, ticketId }) => (
  <div>
    {message || 'Ticket created successfully'}
    <br />
    {ticketId && (
      <a
        href={`${document.location.origin}/pendingbtt/${ticketId}`}
        style={{ color: '#0d6efd', textDecoration: 'underline' }}
      >
        Go to new ticket
      </a>
    )}
  </div>
);

const StatusNew = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.currentUser);
  const userRoles = user?.roles;
  const { isOpen: showAddCommentModal, open: openModal, close: closeModal } = useModal();

  const initialModel = {
    firstName: '',
    lastName: '',
    lastName2: '',
    dateOfBirth: '',
    phone: '',
    gender: '',
    staffSourceMarket: '',
    staffSourceMarketBudget: '',
    season: '',
    country: '',
    destination: '',
    jobTitle: '',
    preferredFlightDate: null,
    typeOfFlight: '',
    luggage: '',
    status: 'PendingBtt',
    isBookReturnFlight: false,
    brfReturnFlightDate: null,
    brfDepartureAirport: '',
    brfArrivalAirport: '',
    isHotelNeeded: false,
    departureAirports: null,
    arrivalAirports: null,
    isRailAndFly: false,
    homeTrainStationName: '',
    noFlightNeeded: false,
  };

  const [newManualFlightTicket, setNewManualFlightTicket] = useState(initialModel);
  const [newManualFlightTicketErrors, setNewManualFlightTicketErrors] = useState({});

  useEffect(() => {
    document.title = 'F2W - New';
    dispatch(getSeasons());
    dispatch(getCountries());
    dispatch(getDestinations());
    dispatch(getJobTitles());
  }, [dispatch]);

  const handleAddManualFlightTicket = (payload) => {
    const errors = {};
    const flightFields = Object.keys(payload);

    for (const field of flightFields) {
      if (
        field === 'lastName2' ||
        field === 'isBookReturnFlight' ||
        field === 'isHotelNeeded' ||
        field === 'isRailAndFly' ||
        field === 'noFlightNeeded' ||
        field === 'flightArrivalTime' ||
        field === 'selectedFiles' ||
        field === 'comment'
      ) {
        continue;
      }
      if (payload[field] === null || payload[field] === '' || !payload[field]) {
        errors[field] = `Please fill in the ${field}`;
      }
    }

    if (!payload.isBookReturnFlight) {
      delete errors.brfReturnFlightDate;
      delete errors.brfDepartureAirport;
      delete errors.brfArrivalAirport;
    }
    if (!payload.isRailAndFly) {
      delete errors.homeTrainStationName;
    }
    if (payload.noFlightNeeded) {
      delete errors.departureAirports;
      delete errors.arrivalAirports;
    }

    if (Object.keys(errors).length > 0) {
      setNewManualFlightTicketErrors(errors);
      return;
    }

    closeModal();
    dispatch(setLoader(true));

    const files = payload.selectedFiles;
    const formData = { ...payload };
    delete formData.selectedFiles;

    FlightTicketApiService.insertManual(files, formData)
      .then((response) => {
        if (response) {
          const ticketId = response.data?.id || response.id;
          toast.success(<TicketCreatedToast message={response.message} ticketId={ticketId} />, { duration: 6000 });
        }
      })
      .catch((error) => {
        F2WCustomLogger.error('Error creating ticket', error, { view: 'New', formData });
      })
      .finally(() => {
        dispatch(setLoader(false));
        setNewManualFlightTicket(initialModel);
      });
  };

  return (
    <React.Fragment>
      <Row>
        <Col style={{ display: 'flex', alignItems: 'center' }}>
          <h4>New</h4>
          <Button
            variant="primary"
            size="sm"
            style={{ marginLeft: '15px', padding: '0px 12px', fontSize: '0.875rem' }}
            onClick={openModal}
            hidden={!userRoles.includes(DS_F2W_Edit)}
          >
            Add Manual Request
          </Button>
        </Col>
      </Row>

      <NewAgGridTable />

      <NewFlightTicketModal
        show={showAddCommentModal}
        onHide={() => {
          closeModal();
          setNewManualFlightTicket(initialModel);
          setNewManualFlightTicketErrors({});
        }}
        newManualFlightTicket={newManualFlightTicket}
        setNewManualFlightTicket={setNewManualFlightTicket}
        newManualFlightTicketErrors={newManualFlightTicketErrors}
        setNewManualFlightTicketErrors={setNewManualFlightTicketErrors}
        onSubmit={handleAddManualFlightTicket}
      />
    </React.Fragment>
  );
};

export default StatusNew;
